import React from 'react'

export default function Reserved() {
  return (
    <div className='reserved'>Houf Robotic® All rights reserved.</div>
  )
}
